import Axios from '@/assets/js/AxiosPlugin'

// 个人优惠劵
export const getCouponList = params => { return Axios.post('/api/Home/User/getCouponList', params) }

// 获取WebsocketToken
export const getWebsocketToken = params => { return Axios.post('/api/Home/User/getWebsocketToken', params) }



// WEBPACK FOOTER //
// ./src/views/mobile/CouponList/apis/index.js